import { webPaths } from "./pageRoutes";

export const AUTH_MODAL_PATHS = [
  "/log-in",
  "/sign-up",
  "/forgot-password",
  "/otp-verification",
  "/reset-password",
];

export const getSafeBackgroundLocation = (location) => {
  const stateBg = location?.state?.backgroundLocation;

  const isAuthPath = (target) => {
    if (!target) return false;
    const path = typeof target === "string" ? target : target?.pathname;
    return AUTH_MODAL_PATHS.includes(path);
  };

  if (stateBg && !isAuthPath(stateBg)) {
    return stateBg;
  }

  if (location?.pathname && !isAuthPath(location.pathname)) {
    return {
      pathname: location.pathname,
      search: location.search || "",
      hash: location.hash || "",
    };
  }

  return { pathname: webPaths?.WebHome || "/", search: "", hash: "" };
};

export const buildAuthModalState = (location, extraState = {}) => {
  const backgroundLocation = getSafeBackgroundLocation(location);

  return {
    ...location?.state,
    ...extraState,
    backgroundLocation,
  };
};
